<button class="left1"  mat-raised-button  (click)="NewOrder();">
    <span class="mdc-button__label colr" >Create an order</span>
</button><br>
<!---------------------------------new ui---------------------------------------------------->

<section class="content-header ">
   
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Sale Orders</h1>
    </div>
    </div>
  
    </section>
    
    <section class="content">
    
    <div class="card">
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 8%">
     Order Number
    </th>

    <th style="width: 20%">
    Date
    </th>

    <th style="width: 30%">
    Company Name
    </th>

    <th style="width: 8%">
    Total Amount
    </th>

    <th style="width: 10%">
    Status
    </th>

    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>
    
    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c?.sequence_no}}
    </a>
    </td>
    
    <td>
    {{DateFormat(c?.createdAt)}}
    </td>

    
    <td>
    {{c?.customer?.customer_name || 'no data'}}
    </td>

    <td>
    {{c?.total_amount}}
    </td>

    <td>
    {{c?.status}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)='getOrderDetails(c._id);'>
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-danger btn-sm left" data-toggle="modal" data-target="#modal-sm" (click)="DeleteOrder(c.saleorder_number,c._id)">
    <i class="fas fa-trash">
    </i>
    Cancel
    </a>
    
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>

<!------------------------------------------------------------>
<div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
    <div class="modal-content">
    
    <div class="modal-body">
    <p>Cancel order No:"{{OrderNumber}}"?</p>
    </div>
    <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal"(click)="CancelOrder();">Yes</button>
    </div>
    </div>
    
    </div>
    
    </div>
